import { render, staticRenderFns } from "./BidsPaymentsModal.vue?vue&type=template&id=71ee42b3&"
import script from "./BidsPaymentsModal.vue?vue&type=script&lang=js&"
export * from "./BidsPaymentsModal.vue?vue&type=script&lang=js&"
import style0 from "./BidsPaymentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports